<section class="container" [attr.aria-label]="pillsWrapperLabel">
    <div *ngFor="let pill of pills" class="filter-pill">
        <span>{{pill.label}}</span>
        <button class="close-button" [attr.aria-label]="getPillAriaLabel(pill.label)" (click)="closePill(pill)">
            <finder-font-icon class="close-icon" name="icon_close-reversed" size="inherit"></finder-font-icon>
        </button>
    </div>
    <finder-button anchor="true" class="clear-button" (click)="clearPills()">{{clearLabel}}</finder-button>
</section>
